const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const MannequinCommandURL: any = {
    PostMannequin: Backofficebff + '/v1/Mannequin/add',
    PutMannequin: Backofficebff + '/v1/Mannequin/update',
    DeleteMannequin: Backofficebff + '/v1/Mannequin/delete',
};

